import {defineMessages, FormattedMessage} from 'react-intl';

import {Icon, view} from '@sail/ui';
import {warning} from '@sail/icons/react/Icon';

const messages = defineMessages({
  title: {
    id: 'mobile_conversations_assistant.unrecoverableErrorScreen.title',
    description: 'Title shown on the screen for an unrecoverable error',
    defaultMessage: 'Something went wrong',
  },
});

export function ErrorScreen() {
  return (
    <view.div
      css={{
        width: '100%',
        height: '100%',
        textAlign: 'center',
        stack: 'y',
        paddingX: 'large',
      }}
      data-testid="error-screen"
      aria-live="assertive"
    >
      <view.div
        css={{
          stack: 'y',
          height: 'fill',
          gap: 'small',
          alignX: 'center',
          alignY: 'center',
        }}
      >
        <Icon icon={warning} size="large" />
        <view.div>
          <FormattedMessage {...messages.title} />
        </view.div>
      </view.div>
    </view.div>
  );
}
